/* eslint-disable jira/filename-case */
// User property names
export const GO_TO_PROJECT_SPOTLIGHT_DISMISSED =
	'polaris.global-fields.go-to-project-spotlight-dismissed';
export const GLOBAL_FIELDS_TOUR_DISMISSED = 'polaris.global-fields.tour-dismissed';
export const EXPLORE_SECTION_MESSAGE_DISMISSED =
	'polaris.project-fields.explore-section-message-dismissed';
export const SEEN_PULSATING_FIELDS_BUTTON = 'polaris.project-fields.seen-pulsating-fields-button';
export const PROJECT_FIELDS_TOUR_DISMISSED = 'polaris.project-fields.tour-dismissed';
export const PROJECT_FIELDS_PAGE_VIEWED = 'polaris.project-fields.page-viewed';
export const TIMELINE_DATES_CONFIG_SECTION_MESSAGE_DISMISSED =
	'polaris.timeline.dates-config-section-message-dismissed';
export const GLOBAL_VIEWS_SECTION_MESSAGE_DISMISSED =
	'polaris.global-views.section-message-dismissed';
export const TIMELINE_WEEKLY_MODE_SPOTLIGHT_SEEN = 'polaris.timeline.weekly-mode-spotlight-seen';
export const COLLECTIONS_TOUR_DISMISSED = 'polaris.collections.tour-dismissed';
export const PREMIUM_MODAL_DISMISSED = 'polaris.premium.modal-dismissed';
export const PREMIUM_LAST_VISIT = 'polaris.premium.last-visit';
// Cross project roadmaps
const CROSS_PROJECT_VIEW_LIST_FIELDS_DISMISSED = 'polaris.cross-project-view.list-fields-dismissed';
const CROSS_PROJECT_VIEW_TIMELINE_FIELDS_DISMISSED =
	'polaris.cross-project-view.timeline-fields-dismissed';
const CROSS_PROJECT_VIEW_BOARD_FIELDS_DISMISSED =
	'polaris.cross-project-view.board-fields-dismissed';
const CROSS_PROJECT_VIEW_MATRIX_FIELDS_DISMISSED =
	'polaris.cross-project-view.matrix-fields-dismissed';
export const CROSS_PROJECT_LIST_VIEW_FIELDS_DISMISSED_KEY = 'listViewfieldsDismissed';
export const CROSS_PROJECT_TIMELINE_VIEW_FIELDS_DISMISSED_KEY = 'timelineViewfieldsDismissed';
export const CROSS_PROJECT_BOARD_VIEW_FIELDS_DISMISSED_KEY = 'boardViewfieldsDismissed';
export const CROSS_PROJECT_MATRIX_VIEW_FIELDS_DISMISSED_KEY = 'matrixViewfieldsDismissed';

export const USER_PROPERTY_BY_STATE_KEY: {
	listViewfieldsDismissed: string;
	timelineViewfieldsDismissed: string;
	boardViewfieldsDismissed: string;
	matrixViewfieldsDismissed: string;
} = {
	[CROSS_PROJECT_LIST_VIEW_FIELDS_DISMISSED_KEY]: CROSS_PROJECT_VIEW_LIST_FIELDS_DISMISSED,
	[CROSS_PROJECT_TIMELINE_VIEW_FIELDS_DISMISSED_KEY]: CROSS_PROJECT_VIEW_TIMELINE_FIELDS_DISMISSED,
	[CROSS_PROJECT_BOARD_VIEW_FIELDS_DISMISSED_KEY]: CROSS_PROJECT_VIEW_BOARD_FIELDS_DISMISSED,
	[CROSS_PROJECT_MATRIX_VIEW_FIELDS_DISMISSED_KEY]: CROSS_PROJECT_VIEW_MATRIX_FIELDS_DISMISSED,
};

// Spotlights
export const GLOBAL_FIELDS_TOUR_SPOTLIGHTS_STEP_1 = 'global-fields.tour.spotlights.step-1';
export const GLOBAL_FIELDS_TOUR_SPOTLIGHTS_STEP_2 = 'global-fields.tour.spotlights.step-2';
export const GLOBAL_FIELDS_TOUR_SPOTLIGHTS_STEP_3 = 'global-fields.tour.spotlights.step-3';
export const GLOBAL_FIELDS_TOUR_SPOTLIGHTS_STEP_4 = 'global-fields.tour.spotlights.step-4';
export const GLOBAL_FIELDS_TOUR_SPOTLIGHTS_STEP_LAST = 'global-fields.tour.spotlights.step-last';
export const GLOBAL_FIELDS_GO_TO_PROJECT_SPOTLIGHT = 'global-fields.go-to-project.spotlight';
export const PROJECT_FIELDS_TOUR_SPOTLIGHTS_STEP_1 = 'project-fields.tour.spotlights.step-1';
export const PROJECT_FIELDS_TOUR_SPOTLIGHTS_STEP_2 = 'project-fields.tour.spotlights.step-2';
export const PROJECT_FIELDS_TOUR_SPOTLIGHTS_STEP_3 = 'project-fields.tour.spotlights.step-3';
export const PROJECT_FIELDS_TOUR_SPOTLIGHTS_STEP_4 = 'project-fields.tour.spotlights.step-4';
export const PROJECT_FIELDS_TOUR_SPOTLIGHTS_STEP_5 = 'project-fields.tour.spotlights.step-5';
export const PROJECT_FIELDS_TOUR_SPOTLIGHTS_STEP_LAST = 'project-fields.tour.spotlights.step-last';

export const COLLECTIONS_CREATE_ROADMAP_SPOTLIGHT = 'collections.create-roadmap.spotlight';
export const COLLECTIONS_CREATE_ROADMAP_SPOTLIGHT_DISMISSED =
	'collections.create-roadmap.spotlight-dismissed';

export const JPD_NAV_VIEWS_SPOTLIGHT = 'jpd-nav-views.spotlight';
export const NAV_JPD_VIEWS_SPOTLIGHT_DISMISSED = 'polaris.nav-jpd-views.spotlight-dismissed';
export const PRIORITIZATION_VIEW_TOUR_SPOTLIGHTS_STEP_1 =
	'prioritization-view.tour.spotlights.step-1';
export const PRIORITIZATION_VIEW_TOUR_SPOTLIGHTS_STEP_LAST =
	'prioritization-view.tour.spotlights.step-last';
export const PRIORITIZATION_VIEW_TOUR_DISMISSED = 'polaris.prioritization-view.tour-dismissed';
export const ROADMAP_VIEW_SPOTLIGHT = 'roadmap-view.spotlight';
export const ROADMAP_VIEW_SPOTLIGHT_DISMISSED = 'polaris.roadmap-view.spotlight-dismissed';
export const ROADMAP_COLUMN_CONFIG_SPOTLIGHT = 'roadmap-view.column-config.spotlight';
export const ROADMAP_COLUMN_CONFIG_SPOTLIGHT_DISMISSED =
	'polaris.roadmap-view.column-config-spotlight-dismissed';

export const ROADMAP_INTRODUCTION_SPOTLIGHT = 'roadmap.introduction.spotlight';
export const ROADMAP_INTRODUCTION_SPOTLIGHT_DISMISSED = 'roadmap.introduction.spotlight.dismissed';
export const ROADMAP_INITIAL_PROMPT_SPOTLIGHT = 'roadmap-view.initial-prompt.spotlight';
export const ROADMAP_INTRODUCTION_SPOTLIGHT_PREREQUISITE_DISMISSALS: string[] = [
	PREMIUM_MODAL_DISMISSED,
	NAV_JPD_VIEWS_SPOTLIGHT_DISMISSED,
];

export const PRODUCT_START_TIMESTAMP = 'polaris.product-start-timestamp';

export const BLUEPRINTS_TOUR_SPOTLIGHTS = 'polaris.blueprints.tour.spotlights';

export const IMPORT_BULK_CREATE_ONBOARDING = 'polaris.import.bulk-create';

export const CUSTOM_DATES_CUSTOMIZE_SPOTLIGHT = 'polaris.custom-dates.customize.spotlight';
export const CUSTOM_DATES_CUSTOMIZE_SPOTLIGHT_DISMISSED =
	'polaris.custom-dates.customize.spotlight-dismissed';

export const UNIFIED_SHARE_DIALOG_SPOTLIGHT = 'polaris.unified-share.spotlight';

export const TREE_VIEW_ONBOARDING_SPOTLIGHT = 'polaris.tree-view.create-menu.spotlight';
export const TREE_VIEW_ONBOARDING_SPOTLIGHT_DISMISSED =
	'polaris.tree-view.onboarding.spotlight-dismissed';
export const CARD_COVERS_SPOTLIGHT = 'polaris.card-covers.spotlight';
export const START_WITH_TEMPLATE_SPOTLIGHT = 'polaris.start-with-template.spotlight';
export const START_WITH_TEMPLATE_SPOTLIGHT_DISMISSED =
	'polaris.start-with-template.spotlight-dismissed';
